module.exports = __webpack_public_path__ + "img/tick.d4704bee.svg";